// extracted by mini-css-extract-plugin
export default {"SubmitButton":"iquKk5Nw","SubmitPlaceholder":"AfE1DBhs"};